import axios from 'axios';

export function getStageHost() {
  if (window?.location.href.indexOf('dev.') !== -1) return 'https://dev.sfr.swingmobility.dev';
  if (window?.location.href.indexOf('stage.') !== -1) return 'https://stage.sfr.swingmobility.dev';
  if (
    window?.location.href.indexOf('http://127.0.0.1') !== -1 || 
    window?.location.href.indexOf('http://localhost') !== -1
  ) return 'https://stage.sfr.swingmobility.dev';
  return 'https://sfr.swingmobility.dev';
}

export function getStagePrefix() {
  if (window?.location.href.indexOf('dev.') !== -1) return 'dev.';
  if (window?.location.href.indexOf('stage.') !== -1) return 'stage.';
  if (window?.location.href.indexOf('http://') !== -1) return 'dev.';

  return '';
}

export async function API(method, path, body, token) {
  const stageHost = getStageHost();
  const r = await axios({
    method,
    url: `${stageHost}${path.substring(0, 1) !== '/' ? '/' : ''}${path}`,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `${token}` } : {}),
    },
    ...(method.toLowerCase() === 'get' || body === null
      ? {}
      : { data: typeof body === 'string' ? body : JSON.stringify(body), }),
    validateStatus: () => true,
  });
  const headers = Object.keys(r.headers)
                        .reduce((m, key) => ({ ...m, [ key.toUpperCase() ]: r.headers[key] }), {});
  
  return {
    status: r.status,
    headers,
    data: r.data,
    code: headers['X-SW-API-STATUS'] ?? r.data.__status,
  };
}
